// src/components/ProductGrid.js
import React, { useState } from "react";
import ProductCard from "./ProductCard";

const ProductGrid = () => {
  // Example product list (you can later replace with API or real data)
  const [products] = useState([
    {
      id: 1,
      name: "Herbal Grinder Pro",
      category: "Grinders",
      price: 29.99,
      image: "https://via.placeholder.com/200x200?text=Grinder",
    },
    {
      id: 2,
      name: "Glass Bong Classic",
      category: "Bongs",
      price: 49.99,
      image: "https://via.placeholder.com/200x200?text=Bong",
    },
    {
      id: 3,
      name: "Pod System X",
      category: "Pod Systems",
      price: 59.99,
      image: "https://via.placeholder.com/200x200?text=Pod+System",
    },
    {
      id: 4,
      name: "Rolling Papers King Size",
      category: "Rolling Papers",
      price: 4.99,
      image: "https://via.placeholder.com/200x200?text=Rolling+Papers",
    },
  ]);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredProducts = products.filter((p) =>
    p.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <section className="max-w-screen-xl mx-auto py-10 px-6">
      {/* Search Bar */}
      <div className="flex justify-center mb-6">
        <input
          type="text"
          placeholder="Search for products, brands or categories..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full md:w-1/2 p-2 rounded-md border border-gray-300 outline-none"
        />
      </div>

      {/* No Results */}
      {filteredProducts.length === 0 ? (
        <p className="text-center text-gray-600 text-lg">
          No results found for "<strong>{searchTerm}</strong>"
        </p>
      ) : (
        /* Product Grid */
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {filteredProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </section>
  );
};

export default ProductGrid;
